import { useTranslation } from "react-i18next";
import { PaywallProps } from ".";
import { NextPlan } from "../../models/next-plan.model";
import { getCurrencySymbol } from "../../utils/currency.utils";
import { Button, Text } from "../common";
import {
  Body,
  Card,
  CardHeader,
  Cards,
  Container,
  Footer,
  Header,
  PriceLabel,
  TextShadow,
  TextTag,
} from "./index.styled";


const PricingPaywall: React.FC<PaywallProps> = ({
  handleClose,
  handleAccept,
  plans,
}) => {
  const { t } = useTranslation();

  const getColor = (plan: NextPlan) => {
    return plan.yearly_amount ? "#441D74" : "#AD6CB9";
  };

  const getValue = (plan: NextPlan) => {
    return plan.yearly_amount ? plan.yearly_amount : plan.monthly_amount;
  };

  return (
    <Container>
        <Header
          url="https://hermes.digitalinnovation.one/assets/talent-header.png"
          minHeight="20rem"
        >
          <TextShadow
            as="p"
            fontSize={35}
            fontWeight={800}
            color={"#7F28B5"}
            maxWidth={300}
            lineHeight={40}
            margin=".5rem 1.5rem"
          >
            {t("private-home-page:paywall.title")}
          </TextShadow>
          <Text
            as="p"
            fontSize={18}
            fontWeight={400}
            color={"#424242"}
            maxWidth={300}
            margin="0 2rem"
          >
            {t("private-home-page:paywall.desc")} <b>{plans[0]?.name}.</b>
          </Text>
        </Header>
        <Body height="18rem">
          <Cards>
            {plans.map((plan) => {
              return (
                <Card>
                  {plan.yearly_amount ? (
                    <CardHeader>
                      <Text
                        as="span"
                        fontSize={12}
                        fontWeight={700}
                        color={"#fff"}
                        align="center"
                      >
                        {t("private-home-page:paywall.opportunite")}
                      </Text>
                    </CardHeader>
                  ) : (
                    <Text
                      as="h4"
                      fontSize={12}
                      fontWeight={700}
                      color={"#424242"}
                      margin=".4rem 0 0 0"
                    >
                      {t("private-home-page:paywall.limit")}
                    </Text>
                  )}

                  <div>
                    <PriceLabel
                      as="span"
                      fontSize={14}
                      fontWeight={400}
                      color={"#424242"}
                      margin="0"
                      style={{
                        transform: `translateY(-${!!plan.yearly_amount ? 50 : 0}%)`
                      }}
                    >
                      {plan.yearly_amount && <span>12x</span>}
                      <span>{getCurrencySymbol(plan.currency)}</span>
                    </PriceLabel>
                    <Text
                      as="span"
                      fontSize={60}
                      fontWeight={800}
                      color={"#424242"}
                      space={-6}
                    >
                      {getValue(plan).split(",")[0] ?? ""}
                    </Text>
                    <Text
                      as="span"
                      fontSize={20}
                      fontWeight={800}
                      color={"#424242"}
                      space={0}
                    >
                      {getValue(plan).split(",").length > 1
                        ? ` ,${getValue(plan)?.split(",")[1]}`
                        : ""}
                    </Text>
                  </div>
                  <TextTag
                    color={getColor(plan)}
                    fontSize={12}
                    fontWeight={800}
                  >
                    {plan.name}
                  </TextTag>
                  <Text
                    as="p"
                    fontSize={35}
                    fontWeight={800}
                    color={getColor(plan)}
                    margin="20px 0"
                  >
                    {plan.yearly_amount
                      ? t("private-home-page:paywall.anual")
                      : t("private-home-page:paywall.month")}
                  </Text>
                  <Text
                    as="p"
                    fontSize={16}
                    fontWeight={400}
                    color={"#000"}
                    margin="0 auto"
                    align="center"
                  >
                    {t("private-home-page:paywall.rule-1", {
                      limit: plan.quota_candidates,
                    })}
                  </Text>
                </Card>
              );
            })}
          </Cards>
        </Body>
        <Footer>
          <Button
            backgroundColor="#7F28B5"
            textColor="#fff"
            onClick={() => {
              handleAccept();
            }}
            width="50%"
          >
            {t("private-home-page:paywall.spec")}
          </Button>
          <Button
            backgroundColor="transparent"
            textColor="#000"
            onClick={() => {
              handleClose();
            }}
            width="50%"
          >
            {t("private-home-page:paywall.close")}
          </Button>
        </Footer>
      </Container>
  )
};

export default PricingPaywall;
